import { getAttrMarkup, IBuildTaskDef, register } from '@wm/transpiler';
import { IDGenerator } from '@wm/core';

const tagName = 'div';
const idGen = new IDGenerator('wm_dialog');

register('wm-dialog', (): IBuildTaskDef => {
    return {
        pre: (attrs) => {
          const counter = idGen.nextUid();
          return `<${tagName} wmDialog #${counter}="wmDialog" 
            ${getAttrMarkup(attrs)} aria-modal="true" role="dialog"
            wm-navigable-element="true"><ng-template #dialogBody>`;
        },
        post: () => `</ng-template></${tagName}>`
    };
});

export default () => {};

